<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="12" offset-sm="0">
        <v-card id="customerlistcard" :loading="loading">
          <h2 v-if="!!!customerList">Keine Kunden gefunden</h2>
          <v-data-table
            :headers="headers"
            :items="customerList"
            :search="search"
            :itemsPerPage="-1"
            multi-sort
          >
            <template v-slot:top>
              <v-text-field
                v-model="search"
                label="Kundensuche"
                class="pa-4"
                :outlined="true"
                :filled="true"
                :clearable="true"
                background-color="#e8eff7"
              ></v-text-field>
            </template>

            <template slot="item.actions" slot-scope="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)"
                >mdi-pencil</v-icon
              >
              <v-icon small class="mr-2" @click="askDeleteCustomer(item)"
                >mdi-delete</v-icon
              >
              <v-icon small class="mr-2" @click="infoItem(item)"
                >mdi-information</v-icon
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dlgDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Kunde löschen?</v-card-title>
        <v-card-text>
          Soll der Kunde
          <strong>{{ deleteCustomerName }}</strong> wirklich gelöscht werden? Es
          werden auch alle Benutzer des Kunden gelöscht!
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" outlined text @click="dlgDelete = false"
            >Abbrechen</v-btn
          >
          <v-btn dark color="red darken-1" @click="deleteCustomer">
            <v-icon>mdi-delete</v-icon>Löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "CustomerList",
  data: () => ({
    loading: false,
    search: "",
    dlgDelete: false,
    deleteItem: false,
    deleteCustomerName: "",
    headers: [
      { text: "Kdnr", value: "kdnr" },
      { text: "Name", value: "name" },
      { text: "Adresse", value: "adresse" },
      { text: "Plz", value: "plz" },
      { text: "Ort", value: "ort" },
      { text: "Telefon", value: "telefon", width: "110px" },
      { text: "Email", value: "email", width: "110px" },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "110px",
        align: "right"
      }
    ]
  }),
  components: {},
  methods: {
    askDeleteCustomer(item) {
      this.deleteCustomerName = item.name1;
      this.dlgDelete = true;
      this.deleteItem = item;
    },
    editItem(item) {
      this.$router.push({ name: "customer-edit", params: { id: item._id } });
    },
    infoItem(item) {
      alert(item.name1);
    },
    deleteCustomer() {
      this.dlgDelete = false;
      this.$store
        .dispatch("customer/deleteCustomer", this.deleteItem._id)
        .then(() => {
          this.$store.dispatch(
            "user/deleteUsersByCustomer",
            this.deleteItem._id
          );

          this.$notify({
            group: "dataline",
            type: "info",
            title: "Kunde gelöscht",
            text: "Kunde " + this.deleteItem.name + " wurde gelöscht"
          });
          this.deleteCustomerName = "";
        })
        .catch(error => {
          console.log(error);
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Löschen fehlgeschlagen",
            text:
              "Kunde " + this.deleteItem.name + " konnte nicht gelöscht werden."
          });
        });
    }
  },

  computed: {
    customerList() {
      return this.$store.getters["customer/getCustomerList"];
    }
  },

  created() {
    this.loading = true;
    this.$store
      .dispatch("customer/fetchCustomerList")
      .then(() => {
        this.loading = false;
      })
      .catch(error => {
        this.loading = false;
        const msg = error.response.data.error
          ? error.response.data.error
          : error.message;
        if (error.response.status != 401) {
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Fehler",
            text: msg
          });
        }
      });
  }
};
</script>

<style scoped>
#customerlistcard {
  margin: 20px;
}
</style>
